import { handleErrorAPIFromRequest, LIST_URL } from '../../@core/utilities/CatchApiError'
import { useForm } from 'antd/lib/form/Form'
import React, { FC, useState } from 'react'
import { submitRegisterEmployerAPI, submitRegisterSocialAPI } from 'src/@legacy/service/api/register.api'
import { useDimention } from 'src/@legacy/@core/hooks/UseDimention'
import { useTranslation } from 'src/@legacy/@core/hooks/UserTranslation'
import { LINK_URL_TOKEN_NOT_FOUND, LINK_URL_COMPANY_JOB_LIST } from 'src/@legacy/utilities/LinkURL'
import RegisterView from './components/RegisterView'
import { readToken } from '../../@core/utilities/JWTToken'
import { useStoreTokenAndFetchUser } from 'src/@legacy/@core/hooks/CurrentUserHooks'
import { toStringFromQuery } from 'src/@legacy/utilities/common'
import { submitLoginWithSocialAPI } from 'src/@legacy/service/api/login.api'
import { openNotificationWithIcon } from 'src/@legacy/@core/utilities/Notification'
import { useRecaptcha, verifyRecaptcha } from 'src/@legacy/@core/utilities/ReCaptcha'
import { useMixpanel } from '../../utilities/Mixpanel'
import useAppRouter from 'src/@legacy/@optimal-page/hooks/useAppRouter'
import useLinkedinLogin from '../login/hooks/useLinkedinLogin'
import { getlinkedinCode } from 'src/utilities/SocialUtilsFunction'
import withRegisterCompanyModal, { OpenRegisterProps } from './withRegisterCompanyModal'

const RegisterWrapper: FC<{} & OpenRegisterProps> = ({ openRegisterCompany }) => {
  const { translate, currentLanguageNumber } = useTranslation()
  const [form] = useForm()
  const [nonFieldError, setNoneFieldError] = useState<string>()
  const [loading, setLoading] = useState(false)
  const router = useAppRouter()
  const fallBackUrl = router.query.redirect
  const storeTokenAndFetchUser = useStoreTokenAndFetchUser()
  const { loaded } = useRecaptcha()
  const { fromProduct } = useDimention()
  const Mixpanel = useMixpanel()
  const [loadingGoogle, setLoadingGoogle] = useState(false)

  const onFinish = (values) => {
    setLoading(true)

    return verifyRecaptcha(values, (isNotGoogleBOT) => {
      if (isNotGoogleBOT) {
        submitRegisterEmployerAPI({ values, fromProduct, currentLanguageNumber })
          .then((response) => {
            return storeTokenAndFetchUser(response.data.token).then(() => {
              const jwt = readToken(response.data.token)
              Mixpanel.alias(jwt.user_id.toString())
              Mixpanel.track(Mixpanel.EVENTS.SIGNUP)
              location.href = fallBackUrl ? decodeURIComponent(toStringFromQuery(fallBackUrl)) : LINK_URL_COMPANY_JOB_LIST(jwt.company_id)
              // router.push(fallBackUrl ? decodeURIComponent(toStringFromQuery(fallBackUrl)) : LINK_URL_COMPANY_JOB_LIST(jwt.company_id))
            })
          })
          .catch((error) => {
            if (!error.response || (error.response && error.response.status === 422)) {
              if (
                error.response &&
                error.response.data?.messages?.msgs &&
                error.response.data?.messages?.msgs[0] === 'Name has already been taken'
              ) {
                setNoneFieldError(translate('notification:name_exist'))
                return openNotificationWithIcon('error', translate('notification:name_exist'), '')
              } else if (
                error.response &&
                error.response.data?.messages?.msgs &&
                error.response.data?.messages?.msgs[0] === 'Email has already been taken'
              ) {
                setNoneFieldError(translate('notification:validate_email_unique'))
                return openNotificationWithIcon('error', translate('notification:validate_email_unique'), '')
              }
            }
            handleErrorAPIFromRequest({
              error,
              page: LIST_URL.REGISTER_CANDIDATE,
              callbackAction: (errorText, errorDescription) => openNotificationWithIcon('error', errorText, errorDescription),
              callbackType: (type) => {
                if (type === 'INVALID_TOKEN') {
                  router.push(LINK_URL_TOKEN_NOT_FOUND)
                }
              }
            })
            throw error
          })
          .finally(() => {
            setLoading(false)
          })
      }
    })
  }

  const socialLogin = (token, provider) => {
    setLoadingGoogle(true)
    // setOpen(!open)
    return submitLoginWithSocialAPI({ token, provider })
      .then((response) => {
        const jwt = readToken(response.data.token)
        // add tracking
        Mixpanel.identifyByToken(response.data.token)
        Mixpanel.trackLogin(Mixpanel.LoginMethod.SOCIAL)
        return storeTokenAndFetchUser(response.data.token).then(() =>
          router.push(fallBackUrl ? decodeURIComponent(toStringFromQuery(fallBackUrl)) : LINK_URL_COMPANY_JOB_LIST(jwt.company_id))
        )
      })
      .catch((error) => {
        if (error.response.data.messages.errors && error.response.data.messages.errors[0] === 'ACCOUNT_NOT_EXIST') {
          openRegisterCompany({
            payload: error.response.data.messages.payload,
            onError: (error) => {
              if (!error.response || (error.response && error.response.status === 422)) {
                if (error.response && error.response.data?.messages?.msgs[0] === 'Name has already been taken') {
                  setNoneFieldError(translate('notification:name_exist'))
                  return openNotificationWithIcon('error', translate('notification:name_exist'), '')
                } else if (error.response && error.response.data?.messages?.msgs[0] === 'Email has already been taken') {
                  setNoneFieldError(translate('notification:validate_email_unique'))
                  return openNotificationWithIcon('error', translate('notification:validate_email_unique'), '')
                }
              }
              handleErrorAPIFromRequest({
                error,
                page: LIST_URL.REGISTER_CANDIDATE,
                callbackAction: (errorText, errorDescription) => openNotificationWithIcon('error', errorText, errorDescription),
                callbackType: (type) => {
                  if (type === 'INVALID_TOKEN') {
                    router.push(LINK_URL_TOKEN_NOT_FOUND)
                  }
                }
              })
            }
          })
        } else {
          handleErrorAPIFromRequest({
            error,
            page: LIST_URL.LOGIN_WITH_SOCIAL,
            callbackAction: (errorText, errorDescription) => openNotificationWithIcon('error', errorText, errorDescription)
          })
        }
      })
      .finally(() => setLoadingGoogle(false))
  }
  /* ----------- FUNCTION HANDLER ----------- */

  const responseGoogle = (response) => {
    if (response.accessToken) {
      return socialLogin(response.accessToken, 1)
    } else {
      return Promise.reject('cannot retrieve access token')
    }
  }

  const googleSocialErrorHandler = (err) => {
    throw err
  }

  const { linkedInLogin: linkedInRegister } = useLinkedinLogin({
    onLoginCode: (code) => {
      return socialLogin(getlinkedinCode(code), 4)
    }
  })
  /* ----------- RENDER ----------- */
  const loginFacebook = (data) => socialLogin(data?.tokenDetail?.accessToken, 0)
  return (
    <>
      <RegisterView
        linkedInRegister={linkedInRegister}
        translate={translate}
        form={form}
        loading={loading}
        router={router}
        nonFieldError={nonFieldError}
        onFinish={onFinish}
        responseGoogle={responseGoogle}
        googleSocialErrorHandler={googleSocialErrorHandler}
        loadingGoogle={loadingGoogle}
        loginFacebook={loginFacebook}
      />
    </>
  )
}
export default withRegisterCompanyModal(RegisterWrapper)
